var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./TextareaForm.ts"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-bef9607c\"}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./TextareaForm.vue.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/forms/extended/Textarea/TextareaForm.vue.html
// module id = J1zc
// module chunks = 2